"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAutomaticEmailStatusToString = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformAutomaticEmailStatusToString(status, isForHuman) {
    switch (status) {
        case legacy_enums_1.AutomaticEmailStatus.Scheduled: // Shedulled to be requested/sent later
            return "scheduled";
        case legacy_enums_1.AutomaticEmailStatus.Requested: // Request sent to mailgun
            if (isForHuman) {
                return "sent";
            }
            return "requested";
        case legacy_enums_1.AutomaticEmailStatus.Accepted: // Mailgun accepted the request to send/forward the email and the message has been placed in queue.
            if (isForHuman) {
                return "sent*";
            }
            return "accepted";
        case legacy_enums_1.AutomaticEmailStatus.Rejected: // Mailgun rejected the request to send/forward the email.
            return "rejected";
        case legacy_enums_1.AutomaticEmailStatus.Delivered: // Mailgun sent the email and it was accepted by the recipient email server.
            return "delivered";
        case legacy_enums_1.AutomaticEmailStatus.Failed: // Mailgun could not deliver the email to the recipient email server.
            return "failed";
        // The email recipient opened the email and enabled image viewing. Open tracking must be enabled in the Mailgun control panel, and the CNAME record must be pointing to mailgun.org.
        case legacy_enums_1.AutomaticEmailStatus.Opened:
            return "opened";
        // The email recipient clicked on a link in the email. Click tracking must be enabled in the Mailgun control panel, and the CNAME record must be pointing to mailgun.org.
        case legacy_enums_1.AutomaticEmailStatus.Clicked:
            return "clicked";
        case legacy_enums_1.AutomaticEmailStatus.Unsubscribed: // The email recipient clicked on the unsubscribe link. Unsubscribe tracking must be enabled in the Mailgun control panel.
            return "unsubscribed";
        // The email recipient clicked on the spam complaint button within their email client. Feedback loops enable the notification to be received by Mailgun.
        case legacy_enums_1.AutomaticEmailStatus.Complained:
            return "complained";
        case legacy_enums_1.AutomaticEmailStatus.Stored: // Mailgun has stored an incoming message
            return "stored";
        case legacy_enums_1.AutomaticEmailStatus.Mixed:
            return "partially failed";
        default:
            return "unknown status";
    }
}
exports.transformAutomaticEmailStatusToString = transformAutomaticEmailStatusToString;
//# sourceMappingURL=transformAutomaticEmailStatusToString.js.map